const BookmarkedListings = () => {
  return <p className="placeholder">Bookmarked Listings</p>;
};

export default BookmarkedListings;
